import React from 'react';
import { DarkModeState } from './src/context/ThemeContext';

export const wrapRootElement = ({ element, props }) => <DarkModeState {...props}>{element}</DarkModeState>;
